import { FilterOption, SelectedFilters } from '../types';

export function sortSelectedFirst(selectedFilters: SelectedFilters) {
  return (a: FilterOption, b: FilterOption) => {
    const aSelected =
      a.slug && selectedFilters?.[a.slug]
        ? (selectedFilters[a.slug] as string[]).includes(a.value)
        : false;
    const bSelected =
      b.slug && selectedFilters?.[b.slug]
        ? (selectedFilters[b.slug] as string[]).includes(b.value)
        : false;
    if (aSelected === bSelected) return 0;
    return aSelected ? -1 : 1;
  };
}
